_.chain = require('lodash/chain')
_.difference = require('lodash/difference')
_.differenceWith = require('lodash/differenceWith')
_.every = require('lodash/every')
_.find = require('lodash/find')
_.findIndex = require('lodash/findIndex')
_.filter = require('lodash/filter')
_.forEach = require('lodash/forEach')
_.get = require('lodash/get')
_.has = require('lodash/has')
_.identity = require('lodash/identity')
_.includes = require('lodash/includes')
_.isArray = require('lodash/isArray')
_.isFunction = require('lodash/isFunction')
_.isNumber = require('lodash/isNumber')
_.isObject = require('lodash/isObject')
_.isString = require('lodash/isString')
_.isEqual = require('lodash/isEqual')
_.isEmpty = require('lodash/isEmpty')
_.keys = require('lodash/keys')
_.keyBy = require('lodash/keyBy')
_.map = require('lodash/map')
_.mapValues = require('lodash/mapValues')
_.omit = require('lodash/omit')
_.omitBy = require('lodash/omitBy')
_.pick = require('lodash/pick')
_.pickBy = require('lodash/pickBy')
_.range = require('lodash/range')
_.snakeCase = require('lodash/snakeCase')
_.sumBy = require('lodash/sumBy')
